import React from 'react';
import wb0 from '../img/Detail/Linocut-Detail.jpg';
import './Detail.css';
const LinoDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default LinoDetail;